var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavigationList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8726 12.0688H37.5061",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5061 22.5005H16.8726",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8726 32.9319H37.5061",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.43153 11.1309C7.91356 11.1309 7.49365 11.5508 7.49365 12.0688C7.49365 12.5867 7.91356 13.0066 8.43153 13.0066C8.94952 13.0066 9.36942 12.5867 9.36942 12.0688C9.36942 11.5508 8.94952 11.1309 8.43153 11.1309Z",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.43153 21.5625C7.91356 21.5625 7.49365 21.9825 7.49365 22.5004C7.49365 23.0184 7.91356 23.4382 8.43153 23.4382C8.94952 23.4382 9.36942 23.0184 9.36942 22.5004C9.36942 21.9825 8.94952 21.5625 8.43153 21.5625Z",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.43153 31.9941C7.91356 31.9941 7.49365 32.414 7.49365 32.932C7.49365 33.4499 7.91356 33.8699 8.43153 33.8699C8.94952 33.8699 9.36942 33.4499 9.36942 32.932C9.36942 32.414 8.94952 31.9941 8.43153 31.9941Z",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationList);
export default __webpack_public_path__ + "static/media/navigation-list.31996273.svg";
export { ForwardRef as ReactComponent };